import { GoalType } from '@griply/types';
import { getInsightsGoals } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useTimeframeTime } from 'features/user';
import { useMemo } from 'react';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';

export const useInsightsGoals = (include?: GoalType[]) => {
  const user = useUser();
  const sortedGoals = useSortedGoals();
  const links = useEntityLinks();
  const { startDate, endDate } = useTimeframeTime();

  return useMemo(
    () =>
      getInsightsGoals({
        goals: sortedGoals,
        insightsSettings: user?.settings?.insights,
        periodStart: startDate,
        periodEnd: endDate,
        include,
        links,
      }),
    [links, sortedGoals, user?.settings?.insights, startDate, endDate, include],
  );
};
